<app-dialog-heading [heading]="heading"></app-dialog-heading>

<div class="dialog-content">
  <form [formGroup]="employmentForm">
    <app-element-input
      [label]="'Employment Number'"
      [required]="true"
      [cssClasses]="['w-100']"
      [formControlName]="controls.EmploymentNumber">
    </app-element-input>
    
    <app-element-input
      [label]="'Income Amount'"
      [type]="'number'"
      [required]="true"
      [cssClasses]="['w-100']"
      [formControlName]="controls.IncomeAmount">
    </app-element-input>
    
    <mat-form-field class="w-100">
      <mat-label>Start Date</mat-label>
      <input matInput
             [matDatepicker]="startDatePicker"
             [formControlName]="controls.StartDate"
             [max]="employmentForm.get(controls.EndDate).value"
             required>
      <mat-datepicker-toggle matIconSuffix [for]="startDatePicker">
      </mat-datepicker-toggle>
      <mat-datepicker #startDatePicker></mat-datepicker>
    </mat-form-field>
    
    <mat-form-field class="w-100">
      <mat-label>End Date</mat-label>
      <input matInput
             [matDatepicker]="endDatePicker"
             [formControlName]="controls.EndDate"
             [min]="employmentForm.get(controls.StartDate).value">
      <mat-datepicker-toggle matIconSuffix [for]="endDatePicker">
      </mat-datepicker-toggle>
      <mat-datepicker #endDatePicker></mat-datepicker>
    </mat-form-field>
  </form>
</div>

<mat-dialog-actions align="center" class="dialog-button-container">
  <button class="dialog-button" mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
  <button class="dialog-button" mat-raised-button color="primary"
          [disabled]="!employmentForm.valid"
          (click)="onSave()">
    Save
  </button>
</mat-dialog-actions>